module.exports = ".by-distance {\r\n    width: 100px;\r\n    float: left;\r\n    padding-top: 10px;\r\n    margin-right: 5px;\r\n}\r\n\r\n.by-distance input {\r\n    width: 40px;\r\n    float: left;\r\n    padding-top: 10px;\r\n    margin-right: 5px;\r\n}\r\n\r\n.by-distance select {\r\n    padding-top: 10px;\r\n    width: 45px;\r\n    float: left;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/add-practice/add-practice.component.css
// module id = ./src/app/shared/components/add-practice/add-practice.component.css
// module chunks = main